module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "shaded m-5",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.form.name.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Name\n                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                        *\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }, _vm.$v.form.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0ad65a99", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad65a99"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/categories/CategoryForm.vue
// module id = 898
// module chunks = 0